(() => {
  if (window.gripbPairPurchaseLoaded) return;
  window.gripbPairPurchaseLoaded = true;
  const views = new Set();
  const instances = new WeakMap();
  let purchasing = false;
  const choices = card => Array.from(card.querySelectorAll('[data-gripb-variant]')).map(input => input.tagName === 'SELECT' ? input.selectedOptions[0] : input).filter(Boolean);
  const available = option => option.dataset.available === 'true' && /^\d+$/.test(option.dataset.variantId || '');
  function setBusy(value) {
    purchasing = value;
    views.forEach(view => view.update());
  }
  function init(root) {
    if (instances.has(root)) return;
    const abort = new AbortController();
    const events = {signal: abort.signal};
    const messages = JSON.parse(root.querySelector('[data-gripb-pair-messages]').textContent);
    const money = new Intl.NumberFormat(root.dataset.locale || 'ko', {style: 'currency', currency: root.dataset.currency || 'KRW'});
    const localViews = [];
    root.querySelectorAll('[data-gripb-purchase-card]').forEach(card => {
      const buy = card.querySelector('[data-gripb-buy]');
      const add = card.querySelector('[data-gripb-add]');
      const single = card.querySelector('[data-gripb-single]');
      const stock = card.querySelector('[data-gripb-stock]');
      const status = card.querySelector('[data-gripb-status]');
      const cartLink = card.querySelector('[data-gripb-cart-link]');
      if (!buy || !add) return;
      const view = {update() {
        const options = choices(card);
        const inStock = options.filter(available);
        const all = options.length > 0 && options.length === inStock.length;
        buy.textContent = options.length > 1 ? messages.buy_pair : messages.buy_product;
        add.textContent = messages.add_pair;
        buy.disabled = add.disabled = purchasing || !all;
        card.querySelectorAll('select[data-gripb-variant]').forEach(select => {select.disabled = purchasing;});
        stock.hidden = all;
        stock.textContent = options.filter(option => !available(option)).map(option => option.dataset.title).join(', ') + ' · ' + (inStock.length ? messages.stock_partial : messages.stock_all);
        single.hidden = inStock.length !== 1 || options.length < 2;
        single.disabled = purchasing || single.hidden;
        if (!single.hidden) single.textContent = inStock[0].dataset.title.replace(/^그립비\s*/, '') + ' ' + messages.buy_only + ' · ' + money.format(Number(inStock[0].dataset.cents) / 100);
      }};
      async function purchase(action, button) {
        if (purchasing || button.disabled) return;
        const options = choices(card);
        const selected = action === 'single' ? options.filter(available) : options;
        if (!selected.length || !selected.every(available)) {view.update();return;}
        const quantities = new Map();
        selected.forEach(option => {
          const id = Number(option.dataset.variantId);
          quantities.set(id, (quantities.get(id) || 0) + 1);
        });
        const items = Array.from(quantities, ([id, quantity]) => ({id, quantity}));
        setBusy(true);
        button.textContent = messages.adding;
        status.hidden = false;
        status.dataset.error = 'false';
        status.textContent = messages.adding;
        cartLink.hidden = true;
        let added = false;
        try {
          const response = await fetch(root.dataset.addUrl, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items})});
          const result = await response.json();
          if (!response.ok || result.status >= 400 || result.errors) {
            status.dataset.error = 'true';
            status.textContent = messages.add_error + (typeof result.description === 'string' ? ' ' + result.description : '');
            cartLink.hidden = false;
            return;
          }
          const returned = Array.isArray(result.items) ? result.items : [result];
          if (!items.every(item => returned.some(line => Number(line.variant_id || line.id) === item.id))) throw new Error('Incomplete cart response');
          added = true;
          status.textContent = messages.redirecting;
          window.location.assign(root.dataset.cartUrl + (action === 'cart' ? '' : '?review=1'));
        } catch (error) {
          status.dataset.error = 'true';
          status.textContent = messages.network_error;
          cartLink.hidden = false;
        } finally {
          if (!added) setBusy(false);
        }
      }
      buy.addEventListener('click', () => purchase('review', buy), events);
      add.addEventListener('click', () => purchase('cart', add), events);
      single.addEventListener('click', () => purchase('single', single), events);
      card.addEventListener('change', event => {
        if (!event.target.matches('[data-gripb-variant]')) return;
        status.hidden = cartLink.hidden = true;
        view.update();
      }, events);
      views.add(view);
      localViews.push(view);
      view.update();
    });
    instances.set(root, () => {abort.abort();localViews.forEach(view => views.delete(view));instances.delete(root);});
  }
  function initWithin(container) {
    if (container.matches?.('[data-gripb-pairs]')) init(container);
    container.querySelectorAll('[data-gripb-pairs]').forEach(init);
  }
  initWithin(document);
  document.addEventListener('shopify:section:load', event => initWithin(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-gripb-pairs]').forEach(root => instances.get(root)?.()));
  window.addEventListener('pageshow', () => setBusy(false));
})();
